module.exports = __webpack_public_path__ + "static/media/zw.bbb9fe47.svg";